import { useState, useRef } from 'react';
import { ReactComponent as Search } from '../../assets/search.svg';
import './index.css';

import { ReactComponent as WalkspanLogo } from '../../assets/walkspan-logo-beta.svg';
import { ReactComponent as UserIcon } from '../../assets/user-icon.svg';
import { ReactComponent as PlayIcon } from '../../assets/play-icon.svg';
import { ReactComponent as CurrentLocation } from '../../assets/location-current.svg';
import { ReactComponent as AlertIcon } from '../../assets/alert-icon.svg';
import { ReactComponent as MenuIcon } from '../../assets/landing-page/menu.svg';

import Show from '../../utility/Show';
import LazyImage from '../../utility/LazyImage';
import { isObjectEmpty, setLSData } from '../../services';
import { carouselImages, carouselPlaceholders } from '../../constants';

import Slider from 'react-slick';

import { Autocomplete } from '../../utility/Autocomplete';

export const AddressSearch = ({ dispatch, actions, state, navigate, openTutorial }) => {
  const {
    currentView,
    isGoogleMapsLoaded,
    userDetails,
    isInTrialMode,
    isMobile,
    isPlugin,
    clientName,
    currentCity,
  } = state;
  const sliderRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isModern = currentView === 'Modern';

  const leftCarouselsettings = {
    dots: false,
    vertical: isMobile ? false : true,
    infinite: true,
    autoplay: false,
    arrows: false,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    className: 'carousel-left-panel',
    slidesToShow: isMobile ? 1.95 : 1.4,
  };

  const rightCarouselsettings = {
    dots: false,
    vertical: true,
    infinite: true,
    autoplay: false,
    arrows: false,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: 'linear',
    className: 'carousel-right-panel',
    slidesToShow: 2,
    slidesToScroll: -1,
  };

  const handleClick = async (address) => {
    actions.sendDataToGoogleAnalytics('used_address_search', {});
    dispatch({ type: 'SET_FROM_LANDING_PAGE', payload: false });
    navigate(`/explore?address=${address.description}`);
    dispatch({ type: 'SET_LOADING', payload: true });
  };

  const openDisclaimer = () => {
    openTutorial();
    dispatch({ type: 'SET_IS_DISCLAIMER_OPEN', payload: true });
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          actions.fetchAddressByLatLng(lat, lng);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  const leftCarousel = () => {
    return (
      <Slider {...leftCarouselsettings}>
        <div>
          <LazyImage
            src={carouselImages[0]}
            placeholder={carouselPlaceholders[0]}
            alt=''
          />
        </div>
        <div>
          <LazyImage
            src={carouselImages[1]}
            placeholder={carouselPlaceholders[1]}
            alt=''
          />
        </div>
        <div>
          <LazyImage
            src={carouselImages[2]}
            placeholder={carouselPlaceholders[2]}
            alt=''
          />
        </div>
      </Slider>
    );
  };

  const rightCarousel = () => {
    return (
      <Slider {...rightCarouselsettings} ref={sliderRef}>
        <div>
          <LazyImage
            src={carouselImages[3]}
            placeholder={carouselPlaceholders[3]}
            alt=''
          />
        </div>
        <div>
          <LazyImage
            src={carouselImages[4]}
            placeholder={carouselPlaceholders[4]}
            alt=''
          />
        </div>
        <div>
          <LazyImage
            src={carouselImages[5]}
            placeholder={carouselPlaceholders[5]}
            alt=''
          />
        </div>
      </Slider>
    );
  };

  const renderTutorialBtn = () => {
    return (
      <div className={`view-tutorial-btn`} onClick={() => openTutorial()}>
        <PlayIcon /> View Tutorial
      </div>
    );
  };

  const handleLogout = () => {
    setLSData('user-data', null);
    setLSData('Agent-Email', null);
    setLSData('Company-Slug', null);
    navigate('/login');
  };

  const renderUserDetails = () => {
    return (
      <div className='user-details-wrapper text-right'>
        {/* <div className='user-icon'>
          <UserIcon />
        </div> */}
        <div>
          <div className='user-name cursor-pointer' onClick={() => navigate('/profile')}>
            Welcome,{' '}
            {isObjectEmpty(userDetails) ||
            userDetails?.email === 'mico.dahang@gmail.com'
              ? 'User'
              : userDetails?.first_name}
          </div>
          <Show.When isTrue={!isMobile}>
            <div className='logout-btn' onClick={() => handleLogout()}>
              Logout
            </div>
          </Show.When>
        </div>
      </div>
    );
  };

  const renderHeader = () => {
    return (
      <div className={`landing-page-header ${!isInTrialMode && 'hide-user'} gap-4`}>
        {renderTutorialBtn()}
        <Show.When isTrue={!isPlugin}>
          {renderUserDetails()}
        </Show.When>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className={`landing-sidebar ${isMenuOpen && 'open'}`}>
        {renderUserDetails()}
        <MenuIcon
          className='sideber-menu-btn'
          onClick={() => setIsMenuOpen(false)}
        />
        <div className='landing-sidebar-buttons'>
          <div>My Account</div>
          <div
            className='sidebar-logout-btn'
            onClick={() => actions.handleLogout()}
          >
            Log out
          </div>
        </div>
      </div>
    );
  };

  const styleWrapper = {
    ...actions.getBrandingColor(),
  };

  return (
    <div
      className={`landing-page-container
      ${isMobile && 'mobile-landing-page-container'}
      ${true && 'client-landing-page'}
    `}
    >
      <div
        className={`search-address-container ${
          isModern && 'modern-landing-page'
        }`}
        // style={styleWrapper}
      >
        <div className='landing-overlay'></div>
        <div className='landing-bg'></div>
        <Show.When isTrue={!isMobile}>{renderHeader()}</Show.When>
        <div
          className={`search-address-body ${
            isModern && 'modern-search-address-body'
          }`}
        >
          <div className='search-container'>
            <Show.When isTrue={isMobile && isInTrialMode && !isPlugin}>
              <MenuIcon
                className='landing-menu-btn'
                onClick={() => setIsMenuOpen(true)}
              />
            </Show.When>
            <Show.When isTrue={!clientName}>
              <WalkspanLogo className='logo' />
            </Show.When>
            <div className='slogan'>Your neighborhood, your streets, your story</div>
            <div className='slogan-subtext'> Let <b>us</b> guide your neighborhood search</div>
            <div className='search-address-input'>
              <Autocomplete
                placeholder={'Search an address'}
                className={'w-full'}
                onClick={handleClick}
              />
            </div>
            <div className='current-location-btn' onClick={() => getLocation()}>
              <CurrentLocation /> current location
            </div>
          </div>
        </div>
        {/* <Show.When isTrue={isMobile}>{leftCarousel()}</Show.When> */}
        <div className='landing-page-footer'>
          <div className='disclaimer-btn' onClick={() => openDisclaimer()}>
            <AlertIcon /> Disclaimer
          </div>
          <Show.When isTrue={isMobile}>{renderTutorialBtn()}</Show.When>
        </div>
      </div>
      <Show.When isTrue={!isMobile && false}>
        <div className='carousel-container'>
          {leftCarousel()}
          {rightCarousel()}
        </div>
      </Show.When>
      <Show.When isTrue={isMobile}>{renderSidebar()}</Show.When>
    </div>
  );
};
